
import React, { useEffect, useState } from 'react';
import FoodTypeCard from '../components/FoodTypeCard';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { Spinner } from 'react-bootstrap';

const FoodTypeCardsSelector = ({ sessionToken, onFoodTypeClick }) => {
    const [foodTypes, setFoodTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        if (!sessionToken) return;

        const fetchFoodTypes = async () => {
            try {
                const response = await fetchWithCSRF('/api/v1/food-type', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch food types: ${response.status}`);
                }

                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data)) {
                    throw new Error('Invalid data format: expected an array of food types');
                }

                setFoodTypes(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching food types:', error);
                setError('Failed to load food type options');
            } finally {
                setIsLoading(false);
            }
        };

        fetchFoodTypes();
    }, [sessionToken]);

    if (isLoading) {
        return (
            <div className="text-center my-4">
                <Spinner animation="border" role="status" style={{ color: '#52cd92' }}>
                    <span className="visually-hidden">Loading food types...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-warning" role="alert">
                <p className="mb-0">{error}</p>
            </div>
        );
    }

    if (!foodTypes.length) {
        return (
            <div className="alert alert-info" role="alert">
                <p className="mb-0">No food type options available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="food-type-cards">
            <div className="diet-card-container">
                {foodTypes.map(foodType => (
                    <FoodTypeCard key={foodType.id} foodType={foodType} onClick={onFoodTypeClick} />
                ))}
            </div>
        </div>
    );
};

export default FoodTypeCardsSelector;
